import React from 'react';
import Layout from '../components/Layout';
import HeaderMin from '../components/HeaderMin';
import Footer from '../components/Footer';


const IndexPage = () => (
  <Layout>
        <HeaderMin />

    <article className="container box style3">
      <header>
        <h2> STATE OF THE SHARING ECONOMY IN AUSTRALIA</h2>
        <p>August 20, 2014</p>

        </header>
     
        <section>

        <p>Recently I’ve been taking a more active interest in the sharing economy, particularly with the seemingly meteoric success of global start-up’s like Airbnb and Uber and the impact they are having in Australia. </p>
          
          <p>I’ve collected some current articles about the topic:</p>

<p>The Age about some of the <a href="https://www.theage.com.au/education/the-sharing-economy-20140303-33ygj.html">legal challenges</a> facing the sharing economy. Great to see law firm <a href="https://www.ashurst.com/">Ashurst Australia</a> teaming up with Melbourne Uni to provide the Sustainability Business Clinic where law students provide legal advice to start-up companies under the supervision and guidance of environmental lawyers.</p>

<p>ABC News article about <a href="https://www.abc.net.au/news/2014-08-05/airbnb-uber-proving-a-hit-as-australia-turns-to-sharing-economy/5650484">the benefits of providing sharing economy services</a> Airbnb, Uber proving a hit as Australians turn to ‘sharing economy’ to make extra money</p>

<p>So what about Australian start ups?</p>

<p>Chris Riedy <a href="https://twitter.com/chrisjriedy">@chrisjriedy</a> has put together a great list in his blog post called <a href="http://chrisriedy.me/collaborative-consumption-in-australia/"> Collaborative consumption</a> in Australia which features a number of Australian businesses. The list is categorised as Product Service Systems (or PSS), Redistribution Markets and Collaborative Lifestyles</p>

      
      </section>
  
    </article>

    <Footer />
  </Layout>
);

export default IndexPage;
